var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('div',[(_vm.errorsList.length)?_c('ColumnError',{attrs:{"series":_vm.tableItems,"labels":_vm.labelsData}}):_c('div',{staticStyle:{"min-height":"25vh"}},[_c('p',{staticClass:"text-center info"},[_vm._v(" "+_vm._s(_vm.$t('form.noData'))+" ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }